import React from 'react';

export default ({ color, width, height }) => (
  <svg version="1.1" id="Layer_1" width={width} height={height} viewBox="0 0 35 22" fill={color}>
    <g id="Page-1">
      <g id="_x30_02C-Whole-Home-Data-Backup" transform="translate(-205.000000, -892.000000)">
        <g id="Stacked-Group" transform="translate(195.000000, 892.000000)">
          <g id="Cast" transform="translate(10.000000, 0.000000)">
            <g id="Devices">
              <g id="Laptop" transform="translate(5.000000, 0.000000)">
                <path
                  id="Shape"
                  style={{ fill: color }}
                  d="M29.7,17.6h-1.5V2.3c0-0.6-0.2-1.2-0.7-1.6c-0.4-0.4-1-0.7-1.6-0.7H4C3.4,0,2.9,0.3,2.4,0.7
							C2,1.1,1.8,1.7,1.8,2.3v15.3H0.3c-0.1,0-0.2,0-0.2,0.1C0,17.7,0,17.8,0,17.9v0.6c0,0.7,0.2,1.3,0.7,1.7
							C1.2,20.7,1.8,21,2.4,21h25.1c0.7,0,1.3-0.3,1.7-0.7s0.7-1.1,0.7-1.7v-0.6c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.1
							c0,0-0.1-0.1-0.1-0.1C29.8,17.6,29.7,17.6,29.7,17.6z M2.4,2.3c0-0.4,0.2-0.9,0.5-1.1C3.2,0.8,3.6,0.7,4,0.7h21.9
							c0.2,0,0.4,0,0.6,0.1s0.4,0.2,0.5,0.3c0.2,0.2,0.3,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.6v15.3h-1V2c0,0,0-0.1,0-0.1
							c0,0,0-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1s-0.1,0-0.1,0H3.7c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1
							c0,0.1,0,0.1,0,0.1v15.5h-1V2.3z M10.7,18.2h8.5V19h-8.5V18.2z M19.6,17.6H4.1V2.4h21.9v15.2L19.6,17.6L19.6,17.6z M29.3,18.5
							c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.3-0.8,0.5-1.3,0.5H2.4c-0.5,0-0.9-0.2-1.3-0.5c-0.3-0.3-0.5-0.8-0.5-1.3v-0.3h9.4v1.1
							c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1h9.2c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.2,0.1-0.2v-1.1h9.4L29.3,18.5L29.3,18.5
							z"
                />
              </g>
              <path
                id="Rectangle"
                style={{ fill: '#FFFFFF', stroke: color, strokeWidth: '0.5' }}
                d="M2.2,6.2h5.5c1.1,0,2,0.9,2,2v11.5c0,1.1-0.9,2-2,2H2.2c-1.1,0-2-0.9-2-2V8.2
						C0.2,7.1,1.1,6.2,2.2,6.2z"
              />
              <circle id="Oval" style={{ fill: 'none', stroke: color }} cx="5" cy="18" r="1" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/resources/react-svg/Devices.js